import * as React from 'react';

import { useOnboardingMapServices } from './useOnboardingMapServices';
import { MAX_DISPLAY_MAP_PREVIEW_ONBOARDING_COUNT } from '../../../constants/map';
import { getMapPreviewOnboardingCookie } from '../helpers';

export function useMapPreviewOnboarding() {
  const [timesShown, setTimesShown] = React.useState(0);

  React.useLayoutEffect(() => {
    setTimesShown(getMapPreviewOnboardingCookie());
  }, []);

  const { hasFutureService, hasTransportAccessibilityService } = useOnboardingMapServices();

  let text: React.ReactNode;

  if (hasTransportAccessibilityService && hasFutureService) {
    text = <span>Оцените&nbsp;транспортную доступность и&nbsp;будущее района на годы вперёд</span>;
  } else if (hasTransportAccessibilityService) {
    text = <span>Оцените&nbsp;транспортную доступность рядом и внутри ЖК</span>;
  } else {
    text = <span>Посмотрите, как изменится территория вокруг ЖК</span>;
  }

  const isVisible =
    (hasTransportAccessibilityService || hasFutureService) && timesShown < MAX_DISPLAY_MAP_PREVIEW_ONBOARDING_COUNT;

  return {
    isVisible,
    text,
    timesShown,
  };
}
